import { render, staticRenderFns } from "./dirigentesSocios-crud.vue?vue&type=template&id=1608832a"
import script from "./dirigentesSocios-crud.vue?vue&type=script&lang=js"
export * from "./dirigentesSocios-crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports